module.exports = __webpack_public_path__ + "static/media/wg_thumbnail.09e5a955.png";